import { gql } from "lib/apolloClient";

export const resourceBankItemDetails = {
  resourceBankItem: gql`
    fragment resourceBankItem on ResourceBankResultData {
      mediaType
      thumbURL
      thumbHeight
      thumbWidth
      title
      url
      source
      downloadUrl
      author {
        userName
        firstName
        lastName
        imageUrl
        profileUrl
      }
      extra {
        misc
      }
    }
  `,
};
